import { create } from "zustand"
import api from "../services/api"
import { toast } from "react-toastify"

const useMotivoStore = create((set, get) => ({
  motivos: [],
  loading: false,
  error: null,
  cacheInvalid: true,
  fetching: false,

  fetchMotivos: async () => {
    if (!get().cacheInvalid && get().motivos.length > 0) return
    if (get().fetching) return

    set({ loading: true, error: null, fetching: true })
    try {
      const { data } = await api.get("/motivos-contato/list")
      set({
        motivos: data,
        loading: false,
        cacheInvalid: false,
        fetching: false,
      })
    } catch (error) {
      set({
        error: error.response?.data?.error || "Falha ao carregar motivos",
        loading: false,
        fetching: false,
      })
      toast.error(error.response?.data?.error || "Erro ao buscar motivos")
    }
  },

  createMotivo: async (novoMotivo) => {
    try {
      const { data } = await api.post("/motivos-contato", novoMotivo)
      set((state) => ({
        motivos: [...state.motivos, data],
        cacheInvalid: true,
      }))
      toast.success("Motivo criado com sucesso!")
      return data
    } catch (error) {
      toast.error(error.response?.data?.error || "Erro ao criar motivo")
      throw error
    }
  },

  updateMotivo: async (id, updatedData) => {
    try {
      const { data } = await api.put(`/motivo-contato/${id}`, updatedData)
      set((state) => ({
        motivos: state.motivos.map((motivo) => (motivo.id === id ? { ...motivo, ...data } : motivo)),
        cacheInvalid: true,
      }))
      toast.success("Motivo atualizado!")
      return data
    } catch (error) {
      toast.error(error.response?.data?.error || "Erro ao atualizar motivo")
      throw error
    }
  },

  deleteMotivo: async (id) => {
    try {
      await api.delete(`/motivo-contato/${id}`)
      set((state) => ({
        motivos: state.motivos.filter((motivo) => motivo.id !== id),
        cacheInvalid: true,
      }))
      toast.success("Motivo removido!")
    } catch (error) {
      toast.error(error.response?.data?.error || "Erro ao excluir motivo")
      throw error
    }
  },

  getMotivoById: (id) => {
    return get().motivos.find((motivo) => motivo.id === id)
  },

  invalidateCache: () => {
    set({ cacheInvalid: true })
  },

  getMotivosOptions: () => {
    return get().motivos.map((motivo) => ({
      value: motivo.id,
      label: motivo.descricao,
      original: motivo,
    }))
  },
}))

export default useMotivoStore
